import { Component, ChangeDetectorRef, ChangeDetectionStrategy, ViewRef, Output, EventEmitter, enableProdMode, HostListener } from '@angular/core';
import { SortPipe } from '../../pipe/sort.pipe';
import { Column } from '../../models/column';
import { Distinct } from '../../models/distinct';
import { HelperService } from '../../Services/Helper.Service';
import { FieldStyle } from '../../models/fieldstyle';

@Component({
  selector: 'mdg-datefilter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div *ngIf="showFilter" class='mdg-filter-container'>
  <div class="mdg-datefilter-popup-container">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class='row'>
          <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12" [title]="column.displayName">
            <h3 class="no-margin">{{column.displayName}}</h3>
          </div>
        </div>
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-md-4 col-sm-4 col-xs-6 col-lg-3">
            <h4 class="no-margin top-buffer-5">Filter By : </h4>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-6 col-lg-4">
            <select class="form-control no-radius input-sm" [(ngModel)]='filterBy'>
              <option value="list">List</option>
              <option value="range">Range</option>
              <option value="quarter">Quarter</option>
              <option value="month">Month</option>
              <option value="week">Week</option>
            </select>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12 col-lg-5">
            <div class="mdg-filter-sort">
              <div>
                <h3 class="no-margin top-buffer-5">Sort : </h3>
              </div>
              <div class="sortby" [class.bg-f7f7f7]='distValue.sort === "asc"' (click)='selectSort("asc")'>A-Z</div>
              <div class="sortby" [class.bg-f7f7f7]='distValue.sort === "desc"' (click)='selectSort("desc")'>Z-A</div>
            </div>
          </div>
        </div>
        <hr class="buffer-5-0">
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content" *ngIf="filterBy === 'range'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-4">
            <h4 class="no-margin top-buffer-5">From</h4>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-8">
            <p-calendar [(ngModel)]="fromDate" inputStyleClass='form-control no-radius input-sm'></p-calendar>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-4">
            <h4 class="no-margin top-buffer-5">To</h4>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-8">
            <p-calendar [(ngModel)]="toDate" inputStyleClass='form-control no-radius input-sm'></p-calendar>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content" *ngIf="filterBy === 'quarter'">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-6">
            <h4 class="no-margin top-buffer-5">Select Quarter : </h4>
          </div>
          <div class="col-md-8 col-sm-6 col-xs-6">
            <select class="form-control no-radius input-sm" [(ngModel)]='selectedQuarter'>
              <option *ngFor='let item of quartersArr' [ngValue]="item">{{item.text}}</option>
            </select>
          </div>
          <div class="col-xs-12 text-center">
            <small>
              <b>Q1</b> - Jan, Feb, Mar,
              <b>Q2</b> - Apr, May, Jun,
              <b>Q3</b> - Jul, Aug, Sep,
              <b>Q4</b> - Oct, Nov, Dec</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content" *ngIf="filterBy === 'month'">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-6">
            <h4 class="no-margin top-buffer-5">Select Month : </h4>
          </div>
          <div class="col-md-8 col-sm-6 col-xs-6">
            <select class="form-control no-radius input-sm" [(ngModel)]='selectedMonth'>
              <option *ngFor='let item of monthsArr' [ngValue]="item">{{item.text}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content" *ngIf="filterBy === 'week'">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-6">
            <h4 class="no-margin top-buffer-5">Select Week : </h4>
          </div>
          <div class="col-md-8 col-sm-6 col-xs-6">
            <select class="form-control no-radius input-sm" [(ngModel)]='selectedWeek'>
              <option *ngFor='let item of weeksArr' [ngValue]="item">{{item.text}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content" *ngIf="filterBy === 'list'">
        <div class='border-top-ddd border-left-ddd border-right-ddd'>
          <div class="padding-5 bg-f7f7f7">List of Values
            <div class="pull-right right-buffer-10">
              <i class='fa cursor-pointer' (click)='checkSelection()' [class.fa-check-square-o]='selectAll' [class.padding-right-2]='!selectAll'
                [class.fa-square-o]='!selectAll'></i>
            </div>
          </div>
        </div>
        <div class="mdg-filter-stack-container overflow-y border-ddd">
          <div class="border-bottom-ddd padding-5 mdg-filter-cell" *ngFor="let col of values" [class.text-bold]='col.checked' title="{{ col.value | format:column }}">
            <div>
              <i class='fa fa-reorder cursor-move font-10'></i>
            </div>
            <div class="mdg-filter-cell-value">{{ col.value | format:column }}</div>
            <div>
              <i class='fa cursor-pointer' (click)='addFilter(col)' [class.fa-check-square-o]='col.checked' [class.fa-square-o]='!col.checked'></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-xs-12 text-lg-right text-md-right text-sm-right">
            <button class='btn btn-sm btn-primary right-buffer-10' (click)='applyFilter()'>Apply</button>
            <button class='btn btn-sm btn-default' (click)='showFilter = false'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
})
export class MDGDateFilterComponent {
  column: Column = new Column();
  values: any[] = [];
  distValue: Distinct = new Distinct();
  @Output() updateFilters: EventEmitter<Distinct> = new EventEmitter<Distinct>();
  showFilter: boolean = false;
  selectAll: boolean = false;
  filterBy: string = 'list';
  fromDate: Date;
  toDate: Date;
  weeksArr: any[] = [];
  selectedWeek: any = {};
  quartersArr: any[] = [];
  selectedQuarter: any = {};
  monthsArr: any[] = [];
  selectedMonth: any = {};

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showFilter) {
      this.showFilter = false;
    }
  }

  constructor(private cdRef: ChangeDetectorRef, private helper: HelperService, private sort: SortPipe) {
    this.fromDate = new Date();
    this.toDate = new Date();
    this.column.header = this.helper.getHeaderStyle();
    this.column.cell = this.helper.getCellStyle();
  }

  copyObject(source: Distinct): Distinct {
    const target: Distinct = new Distinct();
    target.col = this.copyColumn(source.col);
    target.filter = this.helper.copyArray(source.filter.map(m => new Date(m)));
    target.sort = source.sort;
    target.values = this.helper.copyArray(source.values.map(m => new Date(m)));
    return target;
  }

  copyColumn(objToCopy: Column): Column {
    const dest = new Column();
    dest.colName = objToCopy.colName;
    dest.displayName = objToCopy.displayName;
    dest.checked = objToCopy.checked;
    dest.selected = objToCopy.selected;
    dest.colOrder = objToCopy.colOrder;
    dest.dataType = objToCopy.dataType;
    dest.header = objToCopy.header;
    dest.cell = objToCopy.cell;
    if (dest.header) {
      dest.header = this.helper.getHeaderStyle();
    }
    if (dest.cell) {
      dest.cell = this.helper.getCellStyle();
    }
    dest.thousandSepartor = objToCopy.thousandSepartor;
    dest.decimalPlaces = objToCopy.decimalPlaces;
    dest.currencySymbol = objToCopy.currencySymbol;
    dest.dateFormat = objToCopy.dateFormat;
    dest.valueField = objToCopy.valueField;
    dest.formula = objToCopy.formula;
    dest.fields = objToCopy.fields;
    return dest;
  }

  ShowFilter(col: Column, distValue: Distinct) {
    this.column = col;
    this.distValue = distValue;
    this.distValue = this.copyObject(distValue);
    this.distValue.values = this.distValue.values.map(element => {
      element = new Date(element);
      return element;
    });
    this.values = this.sort.transformString(this.distValue.values, this.distValue.sort).map(f => {
      return { 'value': f, 'checked': !this.distValue.filter.includes(f) };
    });
    setTimeout(() => {
      this.getWeeks();
    }, 100);
    if (distValue.filterBy === 'range') {
      this.fromDate = distValue.startDate;
      this.toDate = distValue.endDate;
    }
    if (distValue.filterBy === 'quarter') {
      this.selectedQuarter = distValue.filterValue;
    }
    if (distValue.filterBy === 'month') {
      this.selectedMonth = distValue.filterValue;
    }
    if (distValue.filterBy === 'week') {
      this.selectedWeek = distValue.filterValue;
    }
    setTimeout(() => {
      this.checkAllSelected();
    }, 100);
    this.showFilter = true;
    this.detectChanges();
  }

  getWeeks() {
    const sortedDates = this.sort.transformDate(this.distValue.values, 'asc');
    const arrStartDate: any = sortedDates[0];
    const arrEndDate: any = sortedDates[sortedDates.length - 1];

    this.weeksArr = [];
    let sDate = new Date(arrStartDate.getTime());
    sDate = new Date(sDate.setDate(sDate.getDate() - sDate.getDay()));

    while (sDate < arrEndDate) {
      const startDate = sDate.toLocaleDateString();
      const obj: any = {};
      obj['Start'] = new Date(sDate.getTime());
      const endDate = new Date(sDate.setDate(sDate.getDate() + 6));
      obj['End'] = endDate;
      obj['text'] = startDate + ' - ' + endDate.toLocaleDateString();

      this.weeksArr.push(obj);
      sDate.setDate(sDate.getDate() + 1);
    }
    this.quartersArr = this.getQuarters(arrStartDate, arrEndDate);
    this.monthsArr = this.getMonths(arrStartDate, arrEndDate);
  }

  getMonths(s: Date, e: Date): any[] {
    const sDate = new Date(s.getTime());
    const rArr: any = [];
    while (sDate < e) {
      const monthStartDay = new Date(sDate.getFullYear(), sDate.getMonth(), 1);
      const monthEndDay = new Date(sDate.getFullYear(), sDate.getMonth() + 1, 0);
      rArr.push({ 'text': this.helper.getMonthName(sDate.getMonth()) + ' - ' + sDate.getFullYear(), 'Start': monthStartDay, 'End': monthEndDay });
      sDate.setMonth(sDate.getMonth() + 1);
    }
    return rArr;
  }

  getQuarters(d: Date, e: Date): any[] {
    const sDate = new Date(d.getTime());
    const rArr: any[] = [];
    let qStart = this.getQuarter(sDate);
    while (qStart.End < e) {
      rArr.push(qStart);
      sDate.setMonth(sDate.getMonth() + 3);
      qStart = this.getQuarter(sDate);
    }
    if (qStart.End > e) {
      rArr.push(qStart);
    }
    return rArr;
  }

  getQuarter(d: Date): any {
    d = d || new Date(); // If no date supplied, use today
    const q = ['Q1', 'Q2', 'Q3', 'Q4'];
    const qn = q[Math.floor(d.getMonth() / 3)];
    const qStartEnd = this.getQuarterDates(qn, d);
    return { 'text': qn + ' - ' + d.getFullYear(), 'Quarter': qn, 'Year': d.getFullYear(), 'Start': qStartEnd.startDate, 'End': qStartEnd.endDate };
  }

  getQuarterDates(quarter: string, refDate: Date): any {
    let startMonth = 0;
    const startYear = refDate.getFullYear();
    const startDay = 1;
    let endMonth = 0;
    const endYear = refDate.getFullYear();
    let endDay = 31;

    switch (quarter) {
      case 'Q1':
        startMonth = 0;
        endMonth = 2;
        endDay = 31;
        break;

      case 'Q2':
        startMonth = 3;
        endMonth = 5;
        endDay = 30;
        break;

      case 'Q3':
        startMonth = 6;
        endMonth = 8;
        endDay = 30;
        break;

      case 'Q4':
        startMonth = 9;
        endMonth = 11;
        endDay = 31;
        break;
    }
    const startDate = new Date(startYear, startMonth, startDay);
    const endDate = new Date(endYear, endMonth, endDay);
    return { 'startDate': startDate, 'endDate': endDate };
  }

  updateValue() {
    this.values = this.sort.transformDate(this.distValue.values, this.distValue.sort).map(f => {
      return { 'value': f, 'checked': this.values.filter(v => v.value === f && v.checked === true).length > 0 };
    });
  }

  selectSort(sort: any) {
    if (this.distValue.sort !== sort) {
      this.distValue.sort = sort;
    } else {
      this.distValue.sort = '';
    }
    this.updateValue();
  }

  checkAllSelected() {
    this.selectAll = this.values.filter(f => f.checked).length === this.values.length;
  }

  addFilter(col: any) {
    col.checked = !col.checked;
    this.checkAllSelected();
  }

  checkSelection() {
    this.selectAll = !this.selectAll;
    this.values.forEach(col => {
      col.checked = this.selectAll;
    });
  }

  applyFilter() {
    this.distValue.filter = [];
    if (this.filterBy === 'list') {
      this.distValue.filter = this.values.filter(f => f.checked === false).map(m => m.value);
    } else if (this.filterBy === 'range') {
      this.distValue.startDate = this.fromDate;
      this.distValue.endDate = this.toDate;
    } else if (this.filterBy === 'quarter' && this.selectedQuarter !== undefined) {
      this.distValue.startDate = this.selectedQuarter.Start;
      this.distValue.endDate = this.selectedQuarter.End;
    } else if (this.filterBy === 'month' && this.selectedMonth !== undefined) {
      this.distValue.startDate = this.selectedMonth.Start;
      this.distValue.endDate = this.selectedMonth.End;
    } else if (this.filterBy === 'week' && this.selectedWeek !== undefined) {
      this.distValue.startDate = this.selectedWeek.Start;
      this.distValue.endDate = this.selectedWeek.End;
    }
    this.distValue.filterBy = this.filterBy;
    setTimeout(() => {
      this.updateFilters.emit(this.distValue);
    }, 10);
    this.showFilter = false;
  }

  getDisplayDate(input: string) {
    return (new Date(input)).toLocaleDateString();
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }
}
